import { RestResponse, TRestErrorHandler } from "@oceanjs/core";
import { SpringRestConfig } from "../SpringRestConfig";
import { ParameterCreateDto, ParameterReleasesDto, ParameterDto, ParameterDenyDto, ParameterDuplicates } from "../dto";
import { EhpcBaseRestApi } from "../EhpcBaseRestApi";

const resource = SpringRestConfig.services.parameter;

/**
 * implementation of custom api services for parameters
 */
class ParameterServiceApiImpl extends EhpcBaseRestApi {

  public async createParameter(values: ParameterCreateDto, onError?: TRestErrorHandler): Promise<RestResponse<ParameterDto>> {
    const result = await this.postCustomEndpoint<ParameterDto, ParameterCreateDto>('', values, undefined, onError);
    return result;
  }

  public async editParameter(id: number, dto: ParameterCreateDto, onError?: TRestErrorHandler): Promise<RestResponse<ParameterDto>> {
    const result = this.putCustomEndpoint<ParameterDto, ParameterCreateDto>(`${id}`, dto, undefined, onError);
    return result;
  }

  public async releaseParameters(releases: ParameterReleasesDto, onError?: TRestErrorHandler): Promise<RestResponse<ParameterReleasesDto>> {
    const result = this.postCustomEndpoint<ParameterReleasesDto, ParameterReleasesDto>('release', releases, undefined, onError);
    return result;
  }

  public async denyParameter(id: number, dto: ParameterDenyDto, onError?: TRestErrorHandler): Promise<RestResponse<void>> {
    const result = this.postCustomEndpoint<void,ParameterDenyDto>(`${id}/deny`, dto, undefined, onError);
    return result;

  }

  public async checkParameterDuplikate(dto: ParameterCreateDto, onError?: TRestErrorHandler): Promise<RestResponse<ParameterDuplicates>> {
    const result = this.postCustomEndpoint<ParameterDuplicates, ParameterCreateDto>(`duplicates`,dto, undefined, onError);
    return result;
  }

}

export const ParameterServiceApi = new ParameterServiceApiImpl(resource);
